import bottle_icon_01 from '../assets/bottle_icon_01.png';
import dabang_bottle_01 from '../assets/dabang_bottle_01.png';
import dabang_bottle_02 from '../assets/dabang_bottle_02.png';
import dabang_bottle_03 from '../assets/dabang_bottle_03.png';
import dabang_bottle_04 from '../assets/dabang_bottle_04.png';
import dabang_bottle_05 from '../assets/dabang_bottle_05.png';
import dabang_bottle_06 from '../assets/dabang_bottle_06.png';

import sujung_00 from '../assets/sujung_00.png';
import sujung_01 from '../assets/sujung_01.png';
import sujung_02 from '../assets/sujung_02.png';
import sujung_03 from '../assets/sujung_03.png';
import sujung_04 from '../assets/sujung_04.png';
import sujung_05 from '../assets/sujung_05.png';
import sujung_06 from '../assets/sujung_06.png';
import sujung_07 from '../assets/sujung_07.png';
import sujung_08 from '../assets/sujung_08.png';
import sujung_09 from '../assets/sujung_09.png';
import sujung_10 from '../assets/sujung_10.png';
import sujung_11 from '../assets/sujung_11.png';
import sujung_12 from '../assets/sujung_12.png';
import sujung_13 from '../assets/sujung_13.png';
import sujung_14 from '../assets/sujung_14.png';
import sujung_15 from '../assets/sujung_15.png';
import sujung_16 from '../assets/sujung_16.png';

import { scaleLinear } from 'd3-scale';

export const DEFAULT_WELCOME_STATE = {
  windowWidth: 1024,
  windowHeight: 768,
  businessesData: [],
  organizationsData: [],
  ecosystemsData: [],
  orgNetworksData: [],
  artworksData: [],
  artistsData: [],
  mapLoaded: false,
  socialCapitalMapLoaded: false,
  dabangMapLoaded: false,
  currentSelectedBusiness: null,
  currentArtworksTime: 0,
  currentOrgId: null,
  currentArtistId: null,
  currentOrgPhotos: [],
  lightBoxPhoto: null,
  dabangDeliveryName: "sujung",
  dabangDeliveryCurrentTime: 0,
  dabangDeliveryAnimationStatus: "stop" 
};

export const API_URL = process.env.NODE_ENV === "production" ? `https://social-capital.cheongyecheon.com` : "http://10.29.241.9:3000"



export const SC_STEP_ZOOM = [
  {
    longitude: 126.9951430251652,
    latitude: 37.56853425057154,
    zoomScale: scaleLinear().domain([414, 768, 1024, 1280, 1440, 2560]).range([15, 15.5, 16.2, 16.2, 16.2, 16.81]),
    zoom: 16.81,
    minZoom: 12,
    maxZoom: 22,
    pitch: 0,
    bearing: 0,
    mode: "alley"
  },
  {
    longitude: 126.99404090584109,
    latitude: 37.56752001769731,
    zoomScale: scaleLinear().domain([414, 768, 1024, 1280, 1440, 2560]).range([16, 16.5, 17, 17, 17.2, 17.5]),
    zoom: 17.2,
    minZoom: 12,
    maxZoom: 22,
    pitch: 0,
    bearing: 0,
    networkShow: false,
    mode: "alley"
  },
  {
    longitude: 126.99331548897338,
    latitude:  37.56761713979436,
    zoomScale: scaleLinear().domain([414, 768, 1024, 1280, 1440, 2560]).range([15.5, 16, 16.5, 16.8, 17, 17]),
    zoom: 15.5,
    minZoom: 12,
    maxZoom: 22,
    networkShow: true,
    pitch: 0,
    bearing: 0,
    orgNodeId: 678,
    orgId: 700,
    mode: "orgNetworks"
  },
  {
    longitude: 126.99582157381403,
    latitude: 37.568013305317585,
    zoomScale: scaleLinear().domain([414, 768, 1024, 1280, 1440, 2560]).range([15.5, 16, 16, 17, 18.76, 18.76]),
    zoom: 18.76666,
    minZoom: 15,
    maxZoom: 22,
    networkShow: true,
    pitch: 0,
    bearing: 0,
    orgNodeId: 680,
    orgId: 702,
    mode: "orgNetworks"
  },

  {
    longitude: 126.99553328937064,
    latitude: 37.56862063960621,
    zoomScale: scaleLinear().domain([414, 768, 1024, 1280, 1440, 2560]).range([15, 15.5, 16.2, 16.2, 16.2, 16.81]),
    zoom: 16.81,
    minZoom: 15,
    maxZoom: 22,
    networkShow: true,
    pitch: 0,
    bearing: 0,
    mode: "orgNetworks"
  },
  {
    longitude: 126.99553328937064,
    latitude: 37.56862063960621,
    zoomScale: scaleLinear().domain([414, 768, 1024, 1280, 1440, 2560]).range([15, 15.5, 16.2, 16.2, 16.2, 16.81]),
    zoom: 16.81,
    minZoom: 15,
    maxZoom: 22,
    networkShow: false,
    pitch: 0,
    bearing: 0,
    mode: "artworks"
  },
  {
    longitude: 126.99553328937064,
    latitude: 37.56862063960621,
    zoomScale: scaleLinear().domain([414, 768, 1024, 1280, 1440, 2560]).range([15, 15.5, 16.2, 16.2, 16.2, 16.81]),
    zoom: 16.81,
    minZoom: 15,
    maxZoom: 22,
    networkShow: false,
    pitch: 0,
    bearing: 0,
    mode: "artwork_show"
  }
]

export const DABANGS = {
  "type": "FeatureCollection",
  "name": "dabangs2",
  "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  "features": [
  { "type": "Feature", "properties": { "id": 1, "name": "예전 T다방 (약 2009-2019)", "code": "TB", "type": "before" }, "geometry": { "type": "Point", "coordinates": [ 126.993718700916517, 37.567777147661388 ] } },
  { "type": "Feature", "properties": { "id": 2, "name": "예전 M다방 (2015-2020)", "code": "MB", "type": "before" }, "geometry": { "type": "Point", "coordinates": [ 126.994555437734618, 37.567278430352587 ] } },
  { "type": "Feature", "properties": { "id": 3, "name": "M다방", "code": "MC", "type": "after" }, "geometry": { "type": "Point", "coordinates": [ 126.995019060121692, 37.568292488880488 ] } },
  { "type": "Feature", "properties": { "id": 4, "name": "T다방", "code": "TC", "type": "after" }, "geometry": { "type": "Point", "coordinates": [ 126.995043072436559, 37.568251852655322 ] } },
  { "type": "Feature", "properties": { "id": 5, "name": "예전 T다방 (2019-2020)", "code": "TB", "type": "before" }, "geometry": { "type": "Point", "coordinates": [ 126.994075682072634, 37.567503632387051 ] } },
  { "type": "Feature", "properties": { "id": 6, "name": "S다방", "code": "MC", "type": "after" }, "geometry": { "type": "Point", "coordinates": [ 126.993429, 37.567452 ] } },
  { "type": "Feature", "properties": { "id": 7, "name": "예전 M다방 (2012-2015)", "code": "MB", "type": "before" }, "geometry": { "type": "Point", "coordinates": [ 126.993332799202818, 37.567130376254234 ] } },
  ]
}
  

export const DABANG_DELIVERY_PATH = {
  time: {
    "type": "FeatureCollection",
    "name": "dabang_delivery_path_time",
    "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
    "features": [
    { "type": "Feature", "properties": { "id": 1 }, "geometry": { "type": "MultiLineString", "coordinates": [ [ [ 126.995023244960038, 37.568255402553099 ], [ 126.99504561702561, 37.568309776856182 ], [ 126.9950636, 37.5684027 ], [ 126.99513765630104, 37.568348987073264 ], [ 126.995208367043176, 37.567705853574502 ], [ 126.994954202482461, 37.567709763667537 ], [ 126.994945666711928, 37.56777354004187 ], [ 126.994649534927262, 37.567773878190906 ], [ 126.994639509697137, 37.567888060312868 ], [ 126.994313034569771, 37.567871667290213 ], [ 126.994230607681146, 37.567831031065019 ], [ 126.994174349548643, 37.567782845987217 ], [ 126.994097044439357, 37.567769484388137 ], [ 126.99388202425493, 37.567802564387279 ], [ 126.993671975363711, 37.567849067524627 ], [ 126.993626613420417, 37.567751990402506 ], [ 126.993610743894763, 37.567718028720783 ], [ 126.993575087987864, 37.567673961920725 ], [ 126.993543716942838, 37.567619999759188 ], [ 126.993523398830249, 37.567625541062625 ], [ 126.993517857526811, 37.567597834545445 ], [ 126.993541869841692, 37.567590446140869 ], [ 126.993565882156574, 37.567634776568347 ], [ 126.993584353168032, 37.56762369396148 ], [ 126.993551105347422, 37.567579363534001 ], [ 126.993512484199869, 37.567555287822103 ], [ 126.993490987718459, 37.567456641702009 ], [ 126.993480616608977, 37.567420097765272 ], [ 126.99331813971547, 37.567466921251793 ], [ 126.993280966804932, 37.567483776049741 ], [ 126.993263200441731, 37.567495502310365 ], [ 126.993134653292785, 37.567569796528034 ], [ 126.99306429599477, 37.567418047155918 ], [ 126.993086097634119, 37.567411969992733 ], [ 126.993088637398202, 37.567420512835525 ], [ 126.993078247454278, 37.56742420703781 ], [ 126.993141048893207, 37.567562739623689 ], [ 126.993187226421838, 37.56753318600537 ], [ 126.993183763107169, 37.567520025409721 ], [ 126.993192767725276, 37.567527644701933 ], [ 126.993261110467643, 37.567490702679031 ], [ 126.993283044793714, 37.567466459476506 ], [ 126.993483917043264, 37.567411969992726 ], [ 126.993503311605295, 37.567465074150647 ], [ 126.993671256457333, 37.56745425027929 ], [ 126.993691339038136, 37.567498985820535 ], [ 126.993715497349328, 37.567505479488197 ], [ 126.993706261843613, 37.56753318600537 ], [ 126.993715003682667, 37.567551700692754 ], [ 126.99404229910806, 37.567515236785113 ], [ 126.994085346572973, 37.567677025922031 ], [ 126.99409646196051, 37.567764304536141 ], [ 126.994177272635596, 37.567777465131797 ], [ 126.994232454782292, 37.567824335323365 ], [ 126.99426962769283, 37.567842575447173 ], [ 126.99431580522149, 37.567864278885629 ], [ 126.994642742124142, 37.567896141380373 ], [ 126.994657057158008, 37.567778850457664 ], [ 126.99494797558836, 37.567779543120594 ], [ 126.994958365532312, 37.567713047479373 ], [ 126.995204491759893, 37.56771120037822 ], [ 126.99513765630104, 37.568348987073264 ], [ 126.9950636, 37.5684027 ], [ 126.99504561702561, 37.568309776856182 ], [ 126.995026477387043, 37.568254940777813 ] ] ] } }
    ]
  },
  sujung:{ 
    "type": "FeatureCollection",
    "name": "sujung_dabang_delivery_path",
    "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
    "features": [
    { "type": "Feature", "properties": { "id": 2 }, "geometry": { "type": "MultiLineString", "coordinates": [ [ [ 126.993458170274877, 37.567487366392541 ], [ 126.993492940803748, 37.567465604303862 ], [ 126.993462961060544, 37.567362653229701 ], [ 126.993481221756298, 37.567330616318891 ], [ 126.993430508497184, 37.56727990305977 ], [ 126.993400541571333, 37.567245325837646 ], [ 126.993409762163907, 37.567199222874805 ], [ 126.993382100386199, 37.567185391985959 ], [ 126.993400541571333, 37.567146204467548 ], [ 126.993370574645496, 37.567116237541704 ], [ 126.993382100386199, 37.56707935517143 ], [ 126.993358165359822, 37.567015480321757 ], [ 126.993351491311998, 37.56697689353684 ], [ 126.993347221884363, 37.566918118667779 ], [ 126.993367325562161, 37.566741576496618 ], [ 126.993538850459842, 37.56675202413529 ], [ 126.993568817385693, 37.566733582950157 ], [ 126.99358956371897, 37.566754329283434 ], [ 126.993580343126411, 37.566760092153785 ], [ 126.993378642663998, 37.566747413839011 ], [ 126.99335674375665, 37.566919147375572 ], [ 126.993367116923295, 37.567024031616029 ], [ 126.99343166107127, 37.567229189800649 ], [ 126.993456377368631, 37.567234350848366 ], [ 126.993486984626671, 37.567228037226585 ], [ 126.993663328459519, 37.567217664059946 ], [ 126.993758992107402, 37.567209596041444 ], [ 126.993783484306405, 37.567211901189602 ], [ 126.993798179625813, 37.567209596041444 ], [ 126.99386704592655, 37.567212477476637 ], [ 126.993878571667253, 37.567224003217348 ], [ 126.993921505051404, 37.567223426930298 ], [ 126.993938793662466, 37.567196917726669 ], [ 126.994029847014076, 37.567221121782154 ], [ 126.994054051069554, 37.567139289023117 ], [ 126.994042525328851, 37.567123152986127 ], [ 126.994050593347353, 37.567096643782499 ], [ 126.994026451882036, 37.567067899333601 ], [ 126.994024245146619, 37.567033490074444 ], [ 126.994090933439836, 37.567000980134608 ], [ 126.99411283234717, 37.566973318356901 ], [ 126.994211953717269, 37.566939893708849 ], [ 126.994336431716931, 37.566944504005136 ], [ 126.9943693264064, 37.567032536629355 ], [ 126.99437446666127, 37.567015963597527 ], [ 126.994346804883577, 37.566951419449559 ], [ 126.994140494124878, 37.566969860634693 ], [ 126.994094774854304, 37.566976337855287 ], [ 126.99404426729005, 37.567012018403389 ], [ 126.994024245146619, 37.567033490074444 ], [ 126.994035188116371, 37.567204121985711 ], [ 126.993942251384681, 37.567208443467379 ], [ 126.993845077139724, 37.567211549077072 ], [ 126.993772704764353, 37.567208904847135 ], [ 126.993529771866775, 37.567216336067553 ], [ 126.993423924360343, 37.56723564244205 ], [ 126.993480616608977, 37.567420097765272 ], [ 126.993309964717085, 37.567459630980295 ], [ 126.993269234541771, 37.567478762358483 ], [ 126.993250852449535, 37.567487460339208 ], [ 126.993263200441731, 37.567495502310365 ], [ 126.993134653292785, 37.567569796528034 ], [ 126.993144026965808, 37.567589963396919 ], [ 126.993052142265597, 37.567638539586277 ], [ 126.993059549565146, 37.56764915097871 ], [ 126.993079914652768, 37.567731654802138 ], [ 126.992975241739188, 37.567772052188062 ], [ 126.992926833628204, 37.567791645947267 ], [ 126.992933749072634, 37.567797408817626 ], [ 126.993095109442564, 37.567734017243723 ], [ 126.993065142516713, 37.567641811318047 ], [ 126.993149280423893, 37.567595708355213 ], [ 126.993143517553534, 37.567571504299721 ], [ 126.993277216145756, 37.567491976688828 ], [ 126.99326338525691, 37.567489671540685 ], [ 126.993314098516038, 37.567466620059271 ], [ 126.993475458885953, 37.567428585114925 ], [ 126.993484679478527, 37.567464314911128 ], [ 126.993460475423035, 37.567481603522189 ] ] ] } }
    ]
  }


}
  
  
export const DABANG_PATH_DECK = {
  time: {"path":[[126.99502324496004,37.5682554025531],[126.99504561702561,37.56830977685618],[126.9950636,37.5684027],[126.99513765630104,37.568348987073264],[126.99520836704318,37.5677058535745],[126.99495420248246,37.56770976366754],[126.99494566671193,37.56777354004187],[126.99464953492726,37.567773878190906],[126.99463950969714,37.56788806031287],[126.99431303456977,37.56787166729021],[126.99423060768115,37.56783103106502],[126.99417434954864,37.56778284598722],[126.99409704443936,37.56776948438814],[126.99388202425493,37.56780256438728],[126.99367197536371,37.56784906752463],[126.99362661342042,37.567751990402506],[126.99361074389476,37.56771802872078],[126.99357508798786,37.567673961920725],[126.99354371694284,37.56761999975919],[126.99352339883025,37.567625541062625],[126.99351785752681,37.567597834545445],[126.99354186984169,37.56759044614087],[126.99356588215657,37.56763477656835],[126.99358435316803,37.56762369396148],[126.99355110534742,37.567579363534],[126.99351248419987,37.5675552878221],[126.99349098771846,37.56745664170201],[126.99348061660898,37.56742009776527],[126.99331813971547,37.56746692125179],[126.99328096680493,37.56748377604974],[126.99326320044173,37.567495502310365],[126.99313465329278,37.56756979652803],[126.99306429599477,37.56741804715592],[126.99308609763412,37.56741196999273],[126.9930886373982,37.567420512835525],[126.99307824745428,37.56742420703781],[126.99314104889321,37.56756273962369],[126.99318722642184,37.56753318600537],[126.99318376310717,37.56752002540972],[126.99319276772528,37.56752764470193],[126.99326111046764,37.56749070267903],[126.99328304479371,37.567466459476506],[126.99348391704326,37.567411969992726],[126.9935033116053,37.56746507415065],[126.99367125645733,37.56745425027929],[126.99369133903814,37.567498985820535],[126.99371549734933,37.5675054794882],[126.99370626184361,37.56753318600537],[126.99371500368267,37.56755170069275],[126.99404229910806,37.56751523678511],[126.99408534657297,37.56767702592203],[126.99409646196051,37.56776430453614],[126.9941772726356,37.5677774651318],[126.99423245478229,37.567824335323365],[126.99426962769283,37.56784257544717],[126.99431580522149,37.56786427888563],[126.99464274212414,37.56789614138037],[126.99465705715801,37.567778850457664],[126.99494797558836,37.567779543120594],[126.99495836553231,37.56771304747937],[126.99520449175989,37.56771120037822],[126.99513765630104,37.568348987073264],[126.9950636,37.5684027],[126.99504561702561,37.56830977685618],[126.99502647738704,37.56825494077781]],"timestamps":[0.0029013109999999997,0.066404503,0.1707548092,0.25926678049999996,0.9757981779,1.2003831635,1.2715680387,1.5331873000999998,1.6602252293,1.9492240724999998,2.0348800339,2.1078891237,2.1777762183,2.3712523003,2.5638648319,2.6788206835,2.7190371046,2.7772124067,2.8432058362,2.8621803831,2.8933186175000003,2.9160622192,2.969642286,2.9900772499,3.0473796958,3.0907179797,3.2018385303,3.243420055,3.39607956,3.4338745158,3.4542643097,3.5946086253000002,3.7741364660000003,3.7945441757000005,3.8042876069000005,3.8143408017000007,3.9777999460000006,4.0301469895,4.0450707309,4.0566809835,4.129664560899999,4.162823304199999,4.350307526299999,4.411686981699999,4.560544801599999,4.613270757999999,4.635797655399998,4.667612681199999,4.6895651860999985,4.981535241999999,5.165085350799998,5.2624508804999985,5.335322376499999,5.406615969499999,5.445194952299999,5.492571476099998,5.783561821099998,5.914353897599998,6.171368258799998,6.245739272999997,6.463190467899997,7.173517543599997,7.262029514899997,7.366379821099997,7.4295466649999975]},
  sujung: {"path":[[126.99345817027488,37.56748736639254],[126.99349294080375,37.56746560430386],[126.99346296106054,37.5673626532297],[126.9934812217563,37.56733061631889],[126.99343050849718,37.56727990305977],[126.99340054157133,37.567245325837646],[126.9934097621639,37.567199222874805],[126.9933821003862,37.56718539198596],[126.99340054157133,37.56714620446755],[126.9933705746455,37.567116237541704],[126.9933821003862,37.56707935517143],[126.99335816535982,37.56701548032176],[126.993351491312,37.56697689353684],[126.99334722188436,37.56691811866778],[126.99336732556216,37.56674157649662],[126.99353885045984,37.56675202413529],[126.9935688173857,37.56673358295016],[126.99358956371897,37.566754329283434],[126.99358034312641,37.566760092153785],[126.993378642664,37.56674741383901],[126.99335674375665,37.56691914737557],[126.9933671169233,37.56702403161603],[126.99343166107127,37.56722918980065],[126.99345637736863,37.567234350848366],[126.99348698462667,37.567228037226585],[126.99366332845952,37.567217664059946],[126.9937589921074,37.567209596041444],[126.9937834843064,37.5672119011896],[126.99379817962581,37.567209596041444],[126.99386704592655,37.56721247747664],[126.99387857166725,37.56722400321735],[126.9939215050514,37.5672234269303],[126.99393879366247,37.56719691772667],[126.99402984701408,37.567221121782154],[126.99405405106955,37.56713928902312],[126.99404252532885,37.56712315298613],[126.99405059334735,37.5670966437825],[126.99402645188204,37.5670678993336],[126.99402424514662,37.567033490074444],[126.99409093343984,37.56700098013461],[126.99411283234717,37.5669733183569],[126.99421195371727,37.56693989370885],[126.99433643171693,37.566944504005136],[126.9943693264064,37.567032536629355],[126.99437446666127,37.56701596359753],[126.99434680488358,37.56695141944956],[126.99414049412488,37.56696986063469],[126.9940947748543,37.56697633785529],[126.99404426729005,37.56701201840339],[126.99402424514662,37.567033490074444],[126.99403518811637,37.56720412198571],[126.99394225138468,37.56720844346738],[126.99384507713972,37.56721154907707],[126.99377270476435,37.567208904847135],[126.99352977186678,37.56721633606755],[126.99342392436034,37.56723564244205],[126.99348061660898,37.56742009776527],[126.99330996471708,37.567459630980295],[126.99326923454177,37.56747876235848],[126.99325085244953,37.56748746033921],[126.99326320044173,37.567495502310365],[126.99313465329278,37.56756979652803],[126.99314402696581,37.56758996339692],[126.9930521422656,37.56763853958628],[126.99305954956515,37.56764915097871],[126.99307991465277,37.56773165480214],[126.99297524173919,37.56777205218806],[126.9929268336282,37.56779164594727],[126.99293374907263,37.567797408817626],[126.99309510944256,37.56773401724372],[126.99306514251671,37.56764181131805],[126.99314928042389,37.56759570835521],[126.99314351755353,37.56757150429972],[126.99327721614576,37.56749197668883],[126.99326338525691,37.567489671540685],[126.99331409851604,37.56746662005927],[126.99347545888595,37.567428585114925],[126.99348467947853,37.56746431491113],[126.99346047542303,37.56748160352219]],"timestamps":[0.006712495200000001,0.0457893402,0.1630824942,0.20212832130000002,0.2740686538,0.32069132450000004,0.37250458370000006,0.40136397570000004,0.4478088014,0.4903190355,0.5325015944,0.6064816265999999,0.6497124293,0.7150546134,0.911799075,1.0637786233,1.09724256,1.12667278,1.1370298527,1.3157802085,1.5073637063,1.6241331138000001,1.8588660609,1.8814407744000001,1.9093743076,2.0655920507,2.1505802281,2.1723688662,2.1856013005999997,2.2465260034999996,2.2628760862999995,2.3008114540999993,2.3339618747999995,2.4187710135999994,2.5120790536999995,2.5326805292999994,2.5629537228999992,2.6013293283999994,2.6395693094999992,2.708656949699999,2.744945713499999,2.840049649099999,2.950140512599999,3.0520767803999993,3.071023194999999,3.1467133926999993,3.3301271541999995,3.3711532541999993,3.430813503899999,3.4604920043999994,3.6501200661999995,3.7323660467999997,3.818284897,3.8822904061999997,4.0970706261,4.1930064071999995,4.403767858999999,4.560786834299999,4.602568063499999,4.621460550599998,4.635555655499998,4.7758999710999985,4.7997656704999985,4.897214491599999,4.910687855299999,5.004008224599999,5.106778374099999,5.154756332599999,5.163601444099999,5.322572979399999,5.428279752599999,5.518521254999999,5.545863121899998,5.6933167729999985,5.7058007553999985,5.757394131199998,5.906068377099998,5.946552294699997,5.975282705899997]}
};

export const DABANG_BOTTLES = {
  time: {
    type: "FeatureCollection",
    features: [
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 0.2,
          "disappear_time": 3.25,
          "name": "T다방 출발",
          "url": bottle_icon_01,
          "width": 100,
          "height": 140,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.995043072436559, 37.568251852655322 ]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 19,
          "disappear_time": 20.5,
          "name": "호진정밀",
          "url": dabang_bottle_01,
          "width": 122,
          "height": 161,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [126.993469, 37.567600]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 20,
          "disappear_time": 21.5,
          "name": "광신공업사",
          "url": dabang_bottle_02,
          "width": 196,
          "height": 126,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [126.993592, 37.567620]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 20.8,
          "disappear_time": 22.5,
          "name": "대동정밀",
          "url": dabang_bottle_03,
          "width": 110,
          "height": 153,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [126.99344, 37.567549]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 23,
          "disappear_time": 24.5,
          "name": "대일로구로",
          "url": dabang_bottle_04,
          "width": 115,
          "height": 159,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [126.993189, 37.567461]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 25,
          "disappear_time": 26.5,
          "name": "대성이천정밀",
          "url": dabang_bottle_05,
          "width": 111,
          "height": 170,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [126.993067, 37.567366]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 30,
          "disappear_time": 31.5,
          "name": "다다전자",
          "url": dabang_bottle_06,
          "width": 90,
          "height": 167,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [126.993704, 37.567480]
        }
      },
      
    ]
  },
  sujung: {
    type: "FeatureCollection",
    features: [
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 0.2,
          "disappear_time": 1,
          "name": "S다방 출발",
          "url": sujung_00,
          "width": 122,
          "height": 174,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993429, 37.567452 ]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 1.5,
          "disappear_time": 2.5,
          "name": "동양정밀",
          "url": sujung_01,
          "width": 112,
          "height": 193,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993472, 37.567285 ]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 2.4,
          "disappear_time": 3.4,
          "name": "DS금속",
          "url": sujung_02,
          "width": 134,
          "height": 153,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993359, 37.567224 ]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 3.4,
          "disappear_time": 4.4,
          "name": "영진컴퓨터조각",
          "url": sujung_03,
          "width": 134,
          "height": 208,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.99335, 37.567165 ]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 3.9,
          "disappear_time": 4.9,
          "name": "삼성시보리",
          "url": sujung_04,
          "width": 114,
          "height": 181,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993319, 37.567068 ]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 9,
          "disappear_time": 10,
          "name": "삼일정밀",
          "url": sujung_05,
          "width": 120,
          "height": 173,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993554, 37.566703 ]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 16,
          "disappear_time": 17,
          "name": "선진사",
          "url": sujung_06,
          "width": 166,
          "height": 166,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993533, 37.567179 ]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 17.8,
          "disappear_time": 18.8,
          "name": "조양금속",
          "url": sujung_07,
          "width": 113,
          "height": 166,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993799, 37.567203]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 18,
          "disappear_time": 19,
          "name": "송광산업",
          "url": sujung_08,
          "width": 115,
          "height": 209,
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993836, 37.567201]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 19,
          "disappear_time": 20,
          "name": "명진시보리",
          "url": sujung_09,
          "width": 134,
          "height": 194
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.993919, 37.567156]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 20,
          "disappear_time": 21,
          "name": "신성산업",
          "url": sujung_10,
          "width": 138,
          "height": 214
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.994008, 37.567202]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 21,
          "disappear_time": 22,
          "name": "미정칠",
          "url": sujung_11,
          "width": 121,
          "height": 216
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.994033, 37.567099]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 21.5,
          "disappear_time": 22.5,
          "name": "진성금속",
          "url": sujung_12,
          "width": 116,
          "height": 191
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.994027, 37.567081]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 22.5,
          "disappear_time": 23.5,
          "name": "신진시보리",
          "url": sujung_13,
          "width": 137,
          "height": 165
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.994076, 37.566966]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 23,
          "disappear_time": 24,
          "name": "영풍산업",
          "url": sujung_14,
          "width": 129,
          "height": 201
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.994168, 37.566903]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 23.5,
          "disappear_time": 24.5,
          "name": "서경로구로",
          "url": sujung_15,
          "width": 126,
          "height": 163.85
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.99429, 37.566896]
        }
      },
      {
        "type": "Feature", 
        "properties": { 
          "appear_time": 42,
          "disappear_time": 43.5,
          "name": "아민테크",
          "url": sujung_16,
          "width": 118,
          "height": 154
        }, 
        "geometry": {
          "type": "Point",
          "coordinates": [ 126.992918, 37.567727]
        }
      }
      
    ]
  }
};